export default "__VITE_ASSET__CyyD9HUn__"